import * as Types from '../../../gen/types';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from '@vue/composition-api';
export type ReactiveFunction<TParam> = () => TParam;
export type HolidaySettingQueryVariables = Types.Exact<{
  accessToken?: Types.Maybe<Types.Scalars['String']>;
}>;


export type HolidaySettingQuery = (
  { __typename?: 'Query' }
  & { adjustableTimePeriods: (
    { __typename?: 'AdjustableTimePeriods' }
    & Pick<Types.AdjustableTimePeriods, 'isHolidayAdjustable'>
  ) }
);


export const HolidaySettingDocument = gql`
    query holidaySetting($accessToken: String) {
  adjustableTimePeriods(accessToken: $accessToken) {
    isHolidayAdjustable
  }
}
    `;

/**
 * __useHolidaySettingQuery__
 *
 * To run a query within a Vue component, call `useHolidaySettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useHolidaySettingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHolidaySettingQuery({
 *   accessToken: // value for 'accessToken'
 * });
 */
export function useHolidaySettingQuery(variables: HolidaySettingQueryVariables | VueCompositionApi.Ref<HolidaySettingQueryVariables> | ReactiveFunction<HolidaySettingQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<HolidaySettingQuery, HolidaySettingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HolidaySettingQuery, HolidaySettingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HolidaySettingQuery, HolidaySettingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<HolidaySettingQuery, HolidaySettingQueryVariables>(HolidaySettingDocument, variables, options);
}
export type HolidaySettingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<HolidaySettingQuery, HolidaySettingQueryVariables>;